module.exports = __webpack_public_path__ + "img/activity_write_form.6264450d.png";